/* tslint:disable */
/* eslint-disable */
/**
 * Roles API
 * API for managing user roles
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortailMinimalDto } from './PortailMinimalDto';
import {
    PortailMinimalDtoFromJSON,
    PortailMinimalDtoFromJSONTyped,
    PortailMinimalDtoToJSON,
    PortailMinimalDtoToJSONTyped,
} from './PortailMinimalDto';

/**
 * Portail actif + portails accessibles (mode portail du refacto rôles). estModePortail=false pour un compte legacy sans brique — le front garde alors le sélecteur de rôles historique.
 * 
 * @export
 * @interface GetPortailsResponse
 */
export interface GetPortailsResponse {
    /**
     * Le compte est-il migré aux briques (mode portail) ?
     * @type {boolean}
     * @memberof GetPortailsResponse
     */
    estModePortail: boolean;
    /**
     * 
     * @type {PortailMinimalDto}
     * @memberof GetPortailsResponse
     */
    portailActuel?: PortailMinimalDto;
    /**
     * Portails accessibles au compte, dans l'ordre de préférence
     * @type {Array<PortailMinimalDto>}
     * @memberof GetPortailsResponse
     */
    portails: Array<PortailMinimalDto>;
}

/**
 * Check if a given object implements the GetPortailsResponse interface.
 */
export function instanceOfGetPortailsResponse(value: object): value is GetPortailsResponse {
    if (!('estModePortail' in value) || value['estModePortail'] === undefined) return false;
    if (!('portails' in value) || value['portails'] === undefined) return false;
    return true;
}

export function GetPortailsResponseFromJSON(json: any): GetPortailsResponse {
    return GetPortailsResponseFromJSONTyped(json, false);
}

export function GetPortailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPortailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'estModePortail': json['estModePortail'],
        'portailActuel': json['portailActuel'] == null ? undefined : PortailMinimalDtoFromJSON(json['portailActuel']),
        'portails': ((json['portails'] as Array<any>).map(PortailMinimalDtoFromJSON)),
    };
}

export function GetPortailsResponseToJSON(json: any): GetPortailsResponse {
    return GetPortailsResponseToJSONTyped(json, false);
}

export function GetPortailsResponseToJSONTyped(value?: GetPortailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'estModePortail': value['estModePortail'],
        'portailActuel': PortailMinimalDtoToJSON(value['portailActuel']),
        'portails': ((value['portails'] as Array<any>).map(PortailMinimalDtoToJSON)),
    };
}

